import React from "react";
import loader from "./loader.json";
import loadable from "@loadable/component";
const Lottie = loadable(() => import("react-lottie"), { ssr: false });

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};

const BulletLoader = () => {

    return (
        <Lottie
            options={defaultOptions}
            height={200}
            width={200}
        />
    );
};

export default BulletLoader;
